import { BaseModel } from './../base-model'

export class User extends BaseModel {
  public firstName: string
  public lastName: string
  public email: string

  public get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  public get initials() {
    const isNotEmpty = (str: string) => typeof str === 'string' && str.length > 0
    const first = isNotEmpty(this.firstName) ? this.firstName[0] : ' '
    const last = isNotEmpty(this.lastName) ? this.lastName[0] : ' '
    return `${first}${last}`.toUpperCase()
  }

  constructor(userInfo: any) {
    super()
    this.id = userInfo.id
    this.firstName = userInfo.first_name
    this.lastName = userInfo.last_name
    this.email = userInfo.email
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/user/user.ts